<template>
  <router-view />
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
